export const clientProjects = [
  {
    id: 'faf-core-banking',
    type: 'client',
    title: 'Déploiement d\'un Core Banking Système',
    client: 'FAF Microfinance',
    category: 'Infrastructure & SI Financiers',
    categoryKey: 'infra',
    badgeClass: 'badge-blue',
    imageClass: 'project-image-navy',
    icon: 'server',
    highlight: 'Plateforme Fineract / Mifos X en production',
    context: 'Modernisation du système d\'information et mise en place d\'une plateforme de gestion des opérations de microfinance.',
    deliverables: [
      'Installation et configuration d\'un serveur HPE ProLiant DL380 sous Ubuntu 22.04',
      'Conteneurisation complète de la solution avec Docker Compose',
      'Déploiement de la plateforme Core Banking Apache Fineract / Mifos X',
      'Résolution des problèmes de compatibilité entre images Docker et base de données PostgreSQL',
      'Tests, validation et mise en production de la stack applicative'
    ],
    technologies: ['Apache Fineract', 'Mifos X', 'Docker', 'Docker Compose', 'PostgreSQL 16', 'Ubuntu Server 22.04']
  },
  {
    id: 'bnd-plateforme',
    type: 'client',
    title: 'Plateforme Digitale & Partenariat Stratégique',
    client: 'BND — Bourse Nationale des Déchets',
    category: 'Développement logiciel & Conseil',
    categoryKey: 'software',
    badgeClass: 'badge-green',
    imageClass: 'project-image-green',
    icon: 'code',
    highlight: 'Directeur Technique & Opérations',
    context: 'Structuration et digitalisation d\'une plateforme nationale de gestion et de valorisation des déchets, avec évolution du cadre contractuel vers un partenariat technique.',
    deliverables: [
      'Rédaction des cahiers des charges fonctionnel et technique',
      'Élaboration du protocole de partenariat et du contrat de prestation de services',
      'Conception du dossier UX/UI de la plateforme',
      'Accompagnement technique et opérationnel continu du projet'
    ],
    technologies: ['Conception logicielle', 'Architecture SI', 'UX/UI Design', 'Gestion de projet']
  },
  {
    id: 'wifi-bancaire',
    type: 'client',
    title: 'Solution Hotspot WiFi Multi-Agences',
    client: 'Réseau bancaire national',
    category: 'Réseaux & Télécoms',
    categoryKey: 'network',
    badgeClass: 'badge-blue',
    imageClass: 'project-image-purple',
    icon: 'wifi',
    highlight: '52 agences · 21 villes',
    context: 'Mise en place d\'un accès WiFi sécurisé et centralisé pour un réseau d\'agences bancaires à l\'échelle nationale.',
    deliverables: [
      'Conception de l\'architecture réseau : routeurs MikroTik, passerelles Grandstream GWN double WAN',
      'Mise en place d\'un VPN sécurisé WireGuard entre sites et siège',
      'Déploiement d\'un cluster VMware ESXi en haute disponibilité',
      'Rédaction du cahier des charges du système de gestion des hotspots',
      'Étude financière complète (CAPEX, OPEX mensuel, coût total de possession sur 3 ans)'
    ],
    technologies: ['MikroTik RouterOS', 'Grandstream GWN', 'WireGuard VPN', 'VMware ESXi HA']
  },
  {
    id: 'rafm-telecom',
    type: 'client',
    title: 'Revenue Assurance & Fraud Management',
    client: 'Opérateur télécom national',
    category: 'Cybersécurité & Télécoms',
    categoryKey: 'security',
    badgeClass: 'badge-red',
    imageClass: 'project-image-red',
    icon: 'shield',
    highlight: 'Sous-marque Genius Technology',
    context: 'Sécurisation des revenus et lutte contre la fraude sur les liaisons de télécommunication (LSIP/MPLS), dans une démarche d\'audit de cybersécurité.',
    deliverables: [
      'Conception de l\'architecture de la solution RAFM (diagrammes techniques)',
      'Rédaction de la proposition commerciale et technique',
      'Élaboration de présentations dédiées, dont une version orientée audit de cybersécurité'
    ],
    technologies: ['Revenue Assurance & Fraud Management', 'LSIP/MPLS', 'Cybersécurité télécom']
  }
];

export const ownProjects = [
  {
    id: 'yconnekt',
    type: 'own',
    title: 'YCONNEKT',
    subtitle: 'Partage d\'accès Internet communautaire',
    client: 'Projet propre — Nexus Africa Solutions',
    category: 'Télécoms & Connectivité',
    categoryKey: 'network',
    badgeClass: 'badge-teal',
    imageClass: 'project-image-teal',
    icon: 'wifi',
    highlight: 'Portail captif NEYMA WIFI',
    context: 'Redistribution d\'un accès internet (satellite/fibre) auprès des locataires d\'immeubles résidentiels, avec un modèle d\'ambassadeur local.',
    deliverables: [
      'Conception du modèle économique et du modèle « Gérant de Cité »',
      'Architecture réseau MikroTik hotspot avec authentification et prépaiement Mobile Money',
      'Développement du portail captif de marque NEYMA WIFI',
      'Création des supports marketing (flyers imprimables, formats 4-up et 2-up A4)'
    ],
    technologies: ['MikroTik RouterOS 7', 'Portail captif', 'Intégration Mobile Money']
  },
  {
    id: 'yeco',
    type: 'own',
    title: 'YECO',
    subtitle: 'Plateforme WasteTech',
    client: 'Projet propre — Nexus Africa Solutions',
    category: 'Économie circulaire & Environnement',
    categoryKey: 'environment',
    badgeClass: 'badge-green',
    imageClass: 'project-image-green',
    icon: 'leaf',
    highlight: '4 flux de revenus modélisés',
    context: 'Plateforme numérique de collecte, gestion et valorisation des déchets à destination des ménages et professionnels.',
    deliverables: [
      'Cahier des charges du système d\'information',
      'Modélisation du modèle économique (collecte organique, abonnements, packs mission, vente recyclable)',
      'Élaboration du business plan',
      'Conception du pitch deck investisseurs'
    ],
    technologies: ['Conception SI', 'Modélisation économique', 'Plateforme web']
  },
  {
    id: 'droitfacile',
    type: 'own',
    title: 'DroitFacile',
    subtitle: 'Plateforme LegalTech',
    client: 'Projet propre — Nexus Africa Solutions',
    category: 'LegalTech',
    categoryKey: 'legal',
    badgeClass: 'badge-red',
    imageClass: 'project-image-navy',
    icon: 'legal',
    highlight: 'www.droitfacile.net',
    link: 'https://www.droitfacile.net',
    context: 'Plateforme destinée aux diplômés et jeunes juristes du Cameroun et de la zone OHADA pour faciliter l\'accès à l\'information et aux opportunités juridiques.',
    deliverables: [
      'Cahier des charges fonctionnel et technique',
      'Élaboration du business plan (besoin de financement d\'environ 64,7 millions FCFA)',
      'Communication institutionnelle et intervention au Forum de la Carrière Juridique 2026 à Yaoundé'
    ],
    technologies: ['Plateforme web', 'LegalTech']
  },
  {
    id: 'ytrace',
    type: 'own',
    title: 'YTRACE',
    subtitle: 'Plateforme SaaS de traçabilité agricole',
    client: 'Projet propre — Nexus Africa Solutions',
    category: 'AgriTech / SaaS',
    categoryKey: 'agri',
    badgeClass: 'badge-orange',
    imageClass: 'project-image-orange',
    icon: 'chart',
    highlight: 'Production → commercialisation',
    context: 'Solution SaaS destinée à assurer la traçabilité des filières agricoles, de la production à la commercialisation.',
    deliverables: [
      'Rédaction du cahier des charges',
      'Élaboration du brief UX/UI',
      'Construction du business plan et de la stratégie de financement (80–100 M FCFA)'
    ],
    technologies: ['Plateforme SaaS', 'Traçabilité agricole']
  },
  {
    id: 'mode-edtech',
    type: 'own',
    title: 'MoDE',
    subtitle: 'Mentorship, Développement, Expérience',
    client: 'Projet propre — Nexus Africa Solutions',
    category: 'EdTech',
    categoryKey: 'edtech',
    badgeClass: 'badge-purple',
    imageClass: 'project-image-purple',
    icon: 'education',
    highlight: 'Mentorat & simulation financière',
    context: 'Plateforme visant à rapprocher la formation académique et les besoins réels du marché du travail en Afrique, via le mentorat.',
    deliverables: [
      'Cahier des charges complet de la plateforme',
      'Élaboration du business plan',
      'Conception du modèle de rémunération des mentors',
      'Développement d\'outils financiers interactifs de simulation'
    ],
    technologies: ['Plateforme e-learning', 'Outils de simulation financière']
  }
];

export const allProjects = [...clientProjects, ...ownProjects];

export const projectFilters = {
  client: [
    { id: 'all', label: 'Tous' },
    { id: 'infra', label: 'Infrastructure' },
    { id: 'software', label: 'Logiciel' },
    { id: 'network', label: 'Réseaux' },
    { id: 'security', label: 'Cybersécurité' }
  ],
  own: [
    { id: 'all', label: 'Tous' },
    { id: 'network', label: 'Télécoms' },
    { id: 'environment', label: 'Environnement' },
    { id: 'legal', label: 'LegalTech' },
    { id: 'agri', label: 'AgriTech' },
    { id: 'edtech', label: 'EdTech' }
  ]
};
